"use client";
import Image from "next/image";
import React from "react";
import { Autoplay, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { SwiperOptions } from "swiper/types";
import { testimonial_data } from "@/data/testimonial-data";
import { ifArabic } from "@/utils/language";
import { ArrowIcons } from "../svg";

const swiper_options: SwiperOptions = {
  slidesPerView: 1,
  spaceBetween: 10,
  loop: true,
  navigation: {
    nextEl: ".tp-testimonial-next",
    prevEl: ".tp-testimonial-prev",
  },
  autoplay: {
    delay: 10000,
  },
};

export default function TestimonialSliderOne() {
  return (
    <>
      <Swiper
        {...swiper_options}
        modules={[Navigation, Autoplay]}
        className="swiper tp-testimonial-active"
        style={{ direction: "ltr", userSelect: "none" }}
      >
        {testimonial_data.map((item) => (
          <SwiperSlide
            key={item.id}
            style={{ direction: ifArabic("rtl", "ltr") }}
          >
            <h3 className="tp-testimonial-title">
              {ifArabic(item.titleAr, item.title)}
            </h3>

            <div className="tp-testimonial-avatar">
              <Image src={item.img} alt={item.alt} width={350} height={350} />
            </div>
            <div className="tp-testimonial-content">
              <p>{ifArabic(item.contentAr, item.content)}</p>
            </div>
            <div className="tp-testimonial-avatar-info">
              <h4 className="tp-testimonial-avatar-title">
                {ifArabic(item.nameAr, item.name)}
              </h4>
              <span>{ifArabic(item.positionAr, item.position)}</span>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      <div className="tp-testimonial-arrow text-end">
        {ifArabic(
          <>
            <div className="tp-testimonial-prev pointer">
              <span>
                <ArrowIcons.NextArrow />
              </span>
            </div>
            <div className="tp-testimonial-next pointer">
              <span>
                <ArrowIcons.PrevArrow />
              </span>
            </div>
          </>,
          <>
            <div className="tp-testimonial-prev pointer">
              <span>
                <ArrowIcons.PrevArrow />
              </span>
            </div>
            <div className="tp-testimonial-next pointer">
              <span>
                <ArrowIcons.NextArrow />
              </span>
            </div>
          </>
        )}
      </div>
    </>
  );
}
